var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 13,
    viewBox: "0 0 43 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.702 12.8116H15.2997L17.4277 0.227295H20.8298L18.702 12.8116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.033 0.535766C30.3619 0.281139 29.2975 0 27.9814 0C24.6215 0 22.2555 1.71352 22.241 4.16335C22.2131 5.97082 23.935 6.97474 25.2228 7.5774C26.5391 8.19324 26.9866 8.5952 26.9866 9.14413C26.9732 9.98719 25.9229 10.3758 24.9434 10.3758C23.585 10.3758 22.8572 10.1754 21.7511 9.70641L21.3031 9.50534L20.827 12.3303C21.625 12.6779 23.0952 12.9865 24.6215 13C28.1914 13 30.5156 11.313 30.5431 8.70232C30.5567 7.26975 29.6475 6.17207 27.6872 5.27509C26.4973 4.69929 25.7685 4.31103 25.7685 3.72189C25.7825 3.1863 26.3849 2.63772 27.7282 2.63772C28.8342 2.61085 29.6469 2.86513 30.2626 3.11957L30.5703 3.2532L31.033 0.535766V0.535766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5568 8.35345C35.8369 7.6305 36.9151 4.83246 36.9151 4.83246C36.901 4.85932 37.1947 4.09616 37.3627 3.62765L37.6005 4.71199C37.6005 4.71199 38.2448 7.72427 38.3847 8.35345C37.853 8.35345 36.2288 8.35345 35.5568 8.35345ZM39.7565 0.227295H37.1248C36.3132 0.227295 35.6967 0.454697 35.3465 1.27142L30.2928 12.8115H33.8628C33.8628 12.8115 34.4505 11.2583 34.5768 10.9237C34.9685 10.9237 38.4413 10.9237 38.9451 10.9237C39.0428 11.3656 39.3511 12.8115 39.3511 12.8115H42.5013L39.7565 0.227295V0.227295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4558 0.227295L9.12379 8.80861L8.75969 7.06822C8.14367 5.06004 6.21173 2.87819 4.05579 1.79331L7.10775 12.7983H10.7056L16.0534 0.227295H12.4558V0.227295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03069 0.227295H0.556733L0.500732 0.481565C4.77076 1.52587 7.59872 4.04313 8.7606 7.06875L7.57063 1.28512C7.37472 0.481387 6.77266 0.253807 6.03069 0.227295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_31825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 13,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.18f4969330b704ab3083253fe36ce2bd.svg";
export { ForwardRef as ReactComponent };